export default function scrollTo(position: number | null): void {
  if (position !== null) {
    return window.scrollTo({
      top: position,
      left: 0,
      behavior: 'smooth'
    });
  }
}
